import { i18n } from '@shared/i18n';
import IdField from '@shared/fields/id-field';
import DateTimeRangeField from '@shared/fields/date-time-range-field';
import DateTimeField from '@shared/fields/date-time-field';
import { GenericModel } from '@shared/model/generic-model';
import StringField from '@shared/fields/string-field';
import getSharedEnumeratorField from '@shared/fields/helpers/getSharedEnumeratorField';
import DateModelField from '@shared/fields/date-model-field';
import EnumeratorField from '@shared/fields/enumerator-field';
import AddressField from '@shared/fields/address-field';
import PhoneField from '@shared/fields/phone-field';
import ImagesField from '@shared/fields/images-field';

function label(name) {
    return i18n(`entities.parent.fields.${name}`);
}

const fields = ({ dateFormat, timeFormat }) => ({
    id: new IdField('id', label('id')),
    family: new StringField('family', label('family'), {"required": true    }),
    team: new StringField('team', label('team')),
    firstName: new StringField('firstName', label('firstName'), {"required": true    }),
    lastName: new StringField('lastName', label('lastName'), {"required": true    }),
    email: new StringField('email', label('email'), {"required": true    }),
    birthdate: new DateModelField('birthdate', label('birthdate'), {"required": true    }),
    gender: new EnumeratorField('gender', label('gender'), getSharedEnumeratorField('genderBinary'), { required: true }),
    address: new AddressField('address', label('address')),
    phoneNumber: new PhoneField(      'phoneNumber',      label('phoneNumber'),      { required: true },    ),
    picture: new ImagesField(      'picture',      label('picture'),      (subpropertyId, parentId) => `subproperties/${subpropertyId}/parents/${parentId}/picture`,        {            "required": true,            "max": 1        }    ),
    lastLogin: new DateTimeField('lastLogin', label('lastLogin'), { dateFormat, timeFormat }),
    createdAt: new DateTimeField('createdAt', label('createdAt'), { dateFormat, timeFormat }),
    updatedAt: new DateTimeField('updatedAt', label('updatedAt'), { dateFormat, timeFormat }),
    createdAtRange: new DateTimeRangeField('createdAtRange', label('createdAtRange')),
    birthdateRange: new DateTimeRangeField('birthdateRange', label('birthdateRange')),

});

export class ParentModel extends GenericModel {
    constructor({ dateFormat, timeFormat } = {}) {
        super();
    
        this.dateFormat = dateFormat;
        this.timeFormat = timeFormat;
      }
    
      fields() {
        const { dateFormat, timeFormat } = this;
        return fields({ dateFormat, timeFormat });
      }
    
      presenter(row, fieldName) {
        const fields = this.fields();
    
        if (!fields[fieldName]) {
          throw new Error(`${fieldName} not found`);
        }
    
        return fields[fieldName].forPresenter(
          row[fields[fieldName].name],
        );
      }
    }
    